namespace $.$$ {

	export class $shm_hitalama_entergate_internal_form extends $.$shm_hitalama_entergate_internal_form {

		mode() {
			return 'register'
		}

		register_enabled() {
			return this.login().trim() !== '' && !this.message()
		}

		@ $mol_action
		register( next?: any ) {
			this.$.$giper_baza_auth.current()
			this.pending_login( this.login().trim() )
			this.$.$mol_dom_context.location.reload()
		}

	}

}
